import { z } from 'zod';
import { isValidEmail, isValidPassword } from '../../utils';

type Primitive = string | number | boolean | null | undefined;
type Translate = (key: string, params?: Record<string, Primitive>) => string;

export function createRegisterFormSchema(t: Translate) {
  return z
    .object({
      username: z.string().trim().min(1, t('register.fillRequired')),
      email: z
        .string()
        .trim()
        .min(1, t('register.fillRequired'))
        .refine((value) => isValidEmail(value), t('onboarding.invalidEmail')),
      password: z
        .string()
        .min(1, t('register.fillRequired'))
        .refine((value) => isValidPassword(value), t('register.passwordPolicy')),
      confirmPassword: z.string().min(1, t('register.fillRequired')),
      acceptTerms: z.boolean().refine((value) => value, t('register.acceptTerms')),
    })
    .superRefine(({ password, confirmPassword }, context) => {
      if (password !== confirmPassword) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['confirmPassword'],
          message: t('register.passwordsMismatch'),
        });
      }
    });
}

export type RegisterFormValues = z.infer<ReturnType<typeof createRegisterFormSchema>>;

export const registerFormDefaultValues: RegisterFormValues = {
  username: '',
  email: '',
  password: '',
  confirmPassword: '',
  acceptTerms: false,
};
